import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./reporteAsistenciaDocentes.css";
import { useNavigate } from "react-router-dom";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const ReporteAsistenciaDocentes = () => {

  const navigate = useNavigate()

  const [escuela, setEscuela] = useState("");
  const [fecha, setFecha] = useState("");
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [sede, setSede] = useState("");
const [modoFecha, setModoFecha] = useState("dia"); // "dia" | "periodo"
  const [docentes, setDocentes] = useState([]);
  const [loading, setLoading] = useState(false);

  const [totales, setTotales] = useState({});
  const [consultaFecha, setConsultaFecha] = useState(null);

  const [sortField, setSortField] = useState(null);
  const [sortDir, setSortDir] = useState("asc");

  const [modalData, setModalData] = useState(null);

  const Usuario = ObtieneDatosCookies();

  const escuelas = [
    "Escuela de Policia",
    "Escuela de Especialidades",
    "Escuela Superior",
    "Escuela de Investigaciones",
    "Educacion a Distancia",
    "Extracurricular"
  ];

  // 🔐 convertir permisos en array
  const permisosRaw = Usuario?.funcion
    ? Usuario.funcion.split(",").map((p) => p.trim())
    : [];

  // 🔎 solo permisos de escuela (no horas)
  const permisosEscuelas = permisosRaw.filter((p) =>
    p.startsWith("")
  );

  // 🎯 escuelas permitidas
  const escuelasPermitidas = escuelas.filter((esc) =>
    permisosEscuelas.includes(esc)
  );

  const consultar = async () => {

    if (!escuela) {
      alert("Seleccione una escuela");
      return;
    }

    setLoading(true);

    try {
const body = { escuela };

if (sede) body.sede = sede;

if (modoFecha === "periodo" && fechaDesde && fechaHasta) {
  body.fechaDesde = fechaDesde;
  body.fechaHasta = fechaHasta;
} else if (modoFecha === "dia" && fecha) {
  body.fecha = fecha;
}
      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/docentes/reporteAsistenciaDocentes",
        body
      );

      setDocentes(res.data.docentes || []);
      setTotales({
        totalDocentes: res.data.totalDocentes,
        totalRegistros: res.data.totalRegistros
      });

      setConsultaFecha(new Date());

    } catch (error) {

      console.error(error);
      alert("Error al consultar");

    }

    setLoading(false);
  };

  const ordenar = (field) => {

    let dir = "asc";

    if (sortField === field && sortDir === "asc") {
      dir = "desc";
    }

    setSortField(field);
    setSortDir(dir);

    const sorted = [...docentes].sort((a, b) => {

      if (a[field] < b[field]) return dir === "asc" ? -1 : 1;
      if (a[field] > b[field]) return dir === "asc" ? 1 : -1;
      return 0;

    });

    setDocentes(sorted);
  };

  const descargarExcel = () => {

    if (!docentes.length) return;

    const rows = [];

    docentes.forEach((doc) => {

      doc.registros.forEach((r) => {

        rows.push({
          DNI: doc.docenteDni,
          Apellido: doc.apellido,
          Nombre: doc.nombres,
          Escuela: doc.escuela,
          Sede: doc.sede,
          Fecha: r.fecha,
          Hora: r.hora || "",
          Operacion: r.operacion,
          Cursos: r.cursos
        });

      });

    });

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Reporte");

    const buffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array"
    });

    const file = new Blob([buffer], {
      type: "application/octet-stream"
    });

    saveAs(file, "reporte_asistencia_docentes_" + escuela + ".xlsx");
  };

  return (

    <div className="reporte-container">

      <div style={{ textAlign: "center" }}>
        <button className="btn btn-warning" onClick={() => navigate('../Docentes')}>
          Volver
        </button>
      </div>

      <h2 className="reporte-title">
        Reporte Asistencia Docentes
      </h2>

      <div className="reporte-filtros">

        <select
          className="reporte-input"
          value={escuela}
          onChange={(e) => setEscuela(e.target.value)}
        >

          <option value="">Seleccione una escuela</option>

          {escuelasPermitidas.map((esc) => (
            <option key={esc} value={esc}>
              {esc}
            </option>
          ))}

        </select>

<div style={{ marginBottom: "10px" }}>

  {/* 🔘 Toggle */}
  <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
    
    <button
      className={`btn ${modoFecha === "dia" ? "btn-primary" : "btn-secondary"}`}
      onClick={() => {
        setModoFecha("dia");
        setFechaDesde("");
        setFechaHasta("");
      }}
    >
      📅 Día
    </button>

    <button
      className={`btn ${modoFecha === "periodo" ? "btn-primary" : "btn-secondary"}`}
      onClick={() => {
        setModoFecha("periodo");
        setFecha("");
      }}
    >
      📊 Período
    </button>

  </div>

  {/* 📅 Inputs */}
  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>

    {modoFecha === "dia" && (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>Fecha</span>
        <input
          type="date"
          className="reporte-input"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
      </div>
    )}

    {modoFecha === "periodo" && (
      <>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>Fecha desde</span>
          <input
            type="date"
            className="reporte-input"
            value={fechaDesde}
            onChange={(e) => setFechaDesde(e.target.value)}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>Fecha hasta</span>
          <input
            type="date"
            className="reporte-input"
            value={fechaHasta}
            onChange={(e) => setFechaHasta(e.target.value)}
          />
        </div>
      </>
    )}

  </div>

</div>
        <input
          type="text"
          className="reporte-input"
          placeholder="Sede"
          value={sede}
          onChange={(e) => setSede(e.target.value)}
        />

        <button className="btn-consultar" onClick={consultar}>
          Consultar
        </button>

        <button className="btn-excel" onClick={descargarExcel}>
          Descargar Excel
        </button>

      </div>

      {consultaFecha && (
        <div className="consulta-info">
          Consulta realizada: {consultaFecha.toLocaleString()}
        </div>
      )}

      {loading && <p className="loading">Consultando...</p>}

      {docentes.length > 0 && (
        <div className="reporte-totales">
          <span>Total docentes: {totales.totalDocentes}</span>
          <span>Total registros: {totales.totalRegistros}</span>
        </div>
      )}

      <div className="tabla-wrapper">

        <table className="tabla-docentes">

          <thead>
            <tr>
              <th onClick={() => ordenar("docenteDni")}>DNI</th>
              <th onClick={() => ordenar("apellido")}>Apellido</th>
              <th onClick={() => ordenar("nombres")}>Nombre</th>
              <th onClick={() => ordenar("sede")}>Sede</th>
              <th onClick={() => ordenar("totalAsistencias")}>
                Asistencias
              </th>
            </tr>
          </thead>

          <tbody>

            {docentes.map((doc) => (

              <tr
                key={doc.docenteDni}
                onClick={() => setModalData(doc)}
                className="fila-click"
              >

                <td>{doc.docenteDni}</td>
                <td>{doc.apellido}</td>
                <td>{doc.nombres}</td>
                <td>{doc.sede}</td>
                <td>{doc.totalAsistencias}</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      {modalData && (

        <div className="modal-overlay">

        <div className="modal-content modal-scroll">

            <h3>
              Registros de {modalData.apellido} {modalData.nombres}
            </h3>

            <table className="tabla-modal">

              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Hora</th>
                  <th>Operacion</th>
                  <th>Cursos</th>
                </tr>
              </thead>

              <tbody>

                {modalData.registros.map((r, i) => (

                  <tr key={i}>
                    <td>{r.fecha}</td>
                    <td>{r.hora || "-"}</td>
                    <td>{r.operacion}</td>
                    <td>{r.cursos}</td>
                  </tr>

                ))}

              </tbody>

            </table>

            <button
              className="btn-cerrar"
              onClick={() => setModalData(null)}
            >
              Cerrar
            </button>

          </div>

        </div>

      )}

    </div>
  );
};

export default ReporteAsistenciaDocentes;